import Vue from 'vue';

import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Ripple from 'quasar/src/directives/Ripple.js';;

Vue.use(Quasar, {
    config: {},
    directives: {
        ClosePopup,
        Ripple,
    },
    plugins: {
        Notify,
    },
});